import { Injectable, inject } from '@angular/core';

import { take } from 'rxjs';

import { EnvironmentService } from '../environment/environment.service';
import { FrontendMode } from '../environment/environment.types';
import { removeEmptyObjectProps } from '../helpers';
import { WindowRefService } from '../window-ref/window-ref.service';

import { BaseTrackingDto } from './base-tracking.dto';

export interface MPulseData {
  marketOrganisation?: string;
  locale?: string;
  isLoggedIn?: boolean;
  isEmployee?: boolean;
  isAccountManager?: boolean;
  hasFleetContract?: boolean;
  isMobileApp?: boolean;
  hub?: string;
  frontendMode?: FrontendMode;
  // below props to be added via pageTracking
  templateType?: string;
  productCategory?: string;
}

interface MPulseWindow extends Window {
  mPulseData: MPulseData;
}

@Injectable({
  providedIn: 'root'
})
export class MPulseTrackingService {
  private readonly win = inject<WindowRefService<MPulseWindow>>(WindowRefService).nativeWindow;

  constructor(baseTrackingDto: BaseTrackingDto, { isStandalone, locale }: EnvironmentService) {
    isStandalone &&
      baseTrackingDto
        .update$()
        .pipe(take(1))
        .subscribe(data =>
          this.updateData({
            marketOrganisation: data.country,
            locale,
            isLoggedIn: data.loggedIn,
            isEmployee: data.hiltiUser,
            isAccountManager: data.hiltiSession,
            hasFleetContract: data.fleetContract,
            isMobileApp: data.mobileApp,
            hub: data.region,
            frontendMode: FrontendMode.SPA
          })
        );
  }

  public updateData(data: MPulseData): void {
    this.win.mPulseData = {
      ...this.win.mPulseData,
      ...removeEmptyObjectProps(data)
    };
  }
}
